ux-checkbox {
  display: inline-flex;
  flex-direction: column;
  max-width: 100%;
  position: relative;
}

.ux-checkbox__slot-container .ux-checkbox {
  display: none;
}